import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import ObjectStorageReducer from '../../objectStorage/slice';
import BusinessTechinicianReducer from '../../pages/businessTechnician/slice';
import CartellaAziendaleReducer from '../../pages/cartellaAziendale/slice';
import AddOnReducer from "../../pages/clienti/feature/addOn/slice";
import CompanyCenterReducer from '../../pages/clienti/feature/companyCenter/slice';
import ContactReducer from '../../pages/clienti/feature/contact/slice';
import LegalRapresentativeReducer from "../../pages/clienti/feature/legalRepresentative/slice";
import CustomerReducer from "../../pages/clienti/feature/slice";
import ClientiReducer from '../../pages/clienti/slice';
import EntryAttachmentManagementReducer from '../../pages/gestioneAllegati/entry/dataService/slice';
import PersonaleContabileReducer from '../../pages/gestioneAmministrazione/reportPersonaleContabile/slice';
import ComplianceRequestReducer from '../../pages/gestioneCertificazione/complianceRequests/slice';
import BioSuisseReducer from '../../pages/gestioneClienti/gestioneBiosuisse/slice';
import DemeterReducer from '../../pages/gestioneClienti/gestioneDemeter/slice';
import RegisterReducer from '../../pages/gestioneClienti/registriAziendali/slice';
import RIDReducer from '../../pages/gestioneClienti/RID/slice';
import waiverFromCodexReducer from '../../pages/gestioneControllo/liberatorie/liberatorieFromCodex/dataService/slice';
import waiverToCodexReducer from '../../pages/gestioneControllo/liberatorie/liberatorieToCodex/dataService/slice';
import M018Reducer from '../../pages/gestioneControllo/m018/slice';
import M024Reducer from '../../pages/gestioneControllo/m024/slice';
import PACReducer from '../../pages/gestioneControllo/pac/slice';
import ConversionPeriodReducer from '../../pages/gestioneControllo/periodoConversione/slice';
import ReportingReducer from '../../pages/gestioneControllo/segnalazioni/slice';
import DocumentManagementReducer from '../../pages/gestioneDocumenti/slice';
import DocumentReducer from '../../pages/gestioneDocumenti/uploadedDocuments/slice';
import Re10AnagraficaSliceReducer from '../../pages/gestionePersonale/boxAnagrafica/slice';
import PMCDXM026Reducer from '../../pages/gestionePersonale/boxCDXM026/slice';
import PMcontractsReducer from '../../pages/gestionePersonale/boxContratti/slice';
import PMtrainingReducer from '../../pages/gestionePersonale/boxFormazione/slice';
import PMFunctionsReducer from '../../pages/gestionePersonale/boxFunzioni/slice';
import PMotherDataReducer from '../../pages/gestionePersonale/boxOtherData/slice';
import PMotherInfoReducer from '../../pages/gestionePersonale/boxOtherInfo/slice';
import PMrequirementsReducer from '../../pages/gestionePersonale/boxRequisiti/slice';
import PMevaluationsReducer from '../../pages/gestionePersonale/boxValutazioni/slice';
import PersonalManagementReducer from '../../pages/gestionePersonale/slice';
import CodexSampleReducer from '../../pages/gestionePrelievi/slice';
import MeasureRecipientReducer from '../../pages/gestioneProvvedimenti/measureRecipients/slice';
import OldCodexMeasureReducer from '../../pages/gestioneProvvedimenti/measures/edit/slice';
import NewMeasureReducer from '../../pages/gestioneProvvedimenti/measures/slice';
import OtherOdcMeasuresReducer from '../../pages/gestioneProvvedimenti/measuresOtherOdc/dataService/slice';
import NonComplianceCodesReducer from '../../pages/gestioneProvvedimenti/NonComplianceCode/slice';
import ReinforcedControlMeasure from '../../pages/gestioneProvvedimenti/reinforcedControlMeasure/slice';
import ReportProvvedimentiReducer from '../../pages/gestioneProvvedimenti/reportProvvedimenti/slice';
import SampleCollectionReducer from '../../pages/incarichi/inspectionVisit/edit/gestionePrelievi/slice';
import IVReimbursementReducer from '../../pages/incarichi/inspectionVisit/edit/gestioneRimborsi/slice';
import AssignmentReducer from '../../pages/incarichi/slice';
import MonitoringM24OpenReducer from '../../pages/monitoraggi/monitoraggioM24Aperti/slice';
import MonitoringM24EmessiReducer from '../../pages/monitoraggi/monitoraggioM24Emessi/slice';
import MonitoringNotifiche2023Reducer from '../../pages/monitoraggi/monitoraggioNotifiche/slice';
import MonitoringFaseAvvioReducer from '../../pages/monitoraggi/monitoringFaseAvvio/slice';
import MonitoringValutazioniReducer from '../../pages/monitoraggi/monitoringValutazioni/slice';
import NotComparisonReducer from '../../pages/notifiche/biologica/comparazione/slice';
import NotificationThirdPartyReducer from '../../pages/notifiche/biologica/contoTerzi/slice';
import NotificationImportReducer from '../../pages/notifiche/biologica/importazione/slice';
import ParcelReducer from '../../pages/notifiche/biologica/particelle/slice';
import NotificationProcessingReducer from '../../pages/notifiche/biologica/preparazione/slice';
import NotificationStatusReducer from '../../pages/notifiche/biologica/stato/slice';
import NotificationStructureReducer from '../../pages/notifiche/biologica/strutture/slice';
import NotificationProductiveUnitReducer from '../../pages/notifiche/biologica/unitaProduttive/slice';
import NotificationLivestockReducer from '../../pages/notifiche/biologica/zootecnia/slice';
import GGNotificationCoCReducer from '../../pages/notifiche/globalGap/coc/slice';
import GGNotificationReducer from '../../pages/notifiche/globalGap/dataservice/slice';
import GGNotificationGraspReducer from '../../pages/notifiche/globalGap/grasp/slice';
import ManipulationDetailReducer from '../../pages/notifiche/globalGap/manipolazione/slice';
import GGNotificationCropReducer from '../../pages/notifiche/globalGap/opzione1/slice';
import GGNotificationMemberReducer from '../../pages/notifiche/globalGap/opzione2/slice';
import NotificationSQNPIReducer from '../../pages/notifiche/prodIntegrata/dataService/slice';
import NotificationReducer from '../../pages/notifiche/slice';
import OdcReducer from '../../pages/odc/slice';
import DepartureProtocolReducer from '../../pages/protocol/departure/slice';
import EntryProtocolReducer from '../../pages/protocol/entry/slice';
import Pre2015Reducer from '../../pages/protocol/pre2015/slice';
import BillingWorksheetServiceTypeReducer from '../../pages/schedaCalcolo/slice';
import HeadQuarterReducer from '../../pages/sot/slice';
import UserReducer from '../../pages/users/slice';
import SessionReducer from '../../session/slice';
import LayoutReducer from '../../ui/layout/slice';
import KeycloakReducer from '../keycloak/slice';

// @ts-ignore
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
    key: "root",
    storage,
};

const sessionPersistedReducer = persistReducer(persistConfig, SessionReducer);

export const store = configureStore({
    reducer: {
        keycloak: KeycloakReducer,
        layout: LayoutReducer,
        users: UserReducer,
        clienti: ClientiReducer,
        customer: CustomerReducer, //NUOVO SLICE CLIENTI
        addOn: AddOnReducer, // NUOVO SLICE ADDON
        companyCenter: CompanyCenterReducer, // NUOVO SLICE CENTRI AZIENDALI
        legalRapresentative: LegalRapresentativeReducer, // NUOVO SLICE RAPPRESENTANTE LEGALE
        contact: ContactReducer, // NUOVO SLICE CONTATTI
        businessTechinician: BusinessTechinicianReducer,
        personalManagement: PersonalManagementReducer,
        PMAnagrafica: Re10AnagraficaSliceReducer,
        PMFunctions: PMFunctionsReducer,
        PMEvaluations: PMevaluationsReducer,
        PMContracts: PMcontractsReducer,
        PMOtherData: PMotherDataReducer,
        PMCDXM026: PMCDXM026Reducer,
        PMOtherInfo: PMotherInfoReducer,
        PMRequirement: PMrequirementsReducer,
        PMTraining: PMtrainingReducer,
        entryProtocol: EntryProtocolReducer,
        objectStorage: ObjectStorageReducer,
        departureProtocol: DepartureProtocolReducer,
        documentManagement: DocumentManagementReducer,
        document: DocumentReducer,
        cartellaAziendale: CartellaAziendaleReducer,
        entryAttachManagement: EntryAttachmentManagementReducer,
        rid: RIDReducer,
        waiverFromCodex: waiverFromCodexReducer,
        waiverToCodex: waiverToCodexReducer,
        reporting: ReportingReducer,
        session: sessionPersistedReducer,
        register: RegisterReducer,
        pac: PACReducer,
        complianceRequest: ComplianceRequestReducer,
        conversionPeriod: ConversionPeriodReducer,
        codexSample: CodexSampleReducer,
        reinforcedControlMeasure: ReinforcedControlMeasure,
        odc: OdcReducer,
        oldCodexMeasure: OldCodexMeasureReducer,
        OtherOdcMeasuresState: OtherOdcMeasuresReducer,
        NonComplianceCodes: NonComplianceCodesReducer,
        newMeasure: NewMeasureReducer,
        measureRecipient: MeasureRecipientReducer,
        headQuarter: HeadQuarterReducer,
        billingAndServiceType: BillingWorksheetServiceTypeReducer,
        notificationStatus: NotificationStatusReducer,
        notification: NotificationReducer,
        notificationLivestock: NotificationLivestockReducer,
        notificationUp: NotificationProductiveUnitReducer,
        notificationStructure: NotificationStructureReducer,
        notificationProcessing: NotificationProcessingReducer,
        parcel: ParcelReducer,
        notificationImport: NotificationImportReducer,
        notificationThirdParty: NotificationThirdPartyReducer,
        NotComparison: NotComparisonReducer,
        ggNotification: GGNotificationReducer,
        ggManipulationDetail: ManipulationDetailReducer,
        ggNotificationGrasp: GGNotificationGraspReducer,
        ggNotificationCrop: GGNotificationCropReducer,
        ggNotificationMember: GGNotificationMemberReducer,
        ggNotificationCoC: GGNotificationCoCReducer,
        NotificationSQNPI: NotificationSQNPIReducer,
        assignment: AssignmentReducer,
        sampleCollection: SampleCollectionReducer,
        reimbursement: IVReimbursementReducer,
        bioSuisse: BioSuisseReducer,
        demeter: DemeterReducer,
        pre0215: Pre2015Reducer,
        m024: M024Reducer,
        m018: M018Reducer,
        faseAvvio: MonitoringFaseAvvioReducer,
        m24Open: MonitoringM24OpenReducer,
        m24Emessi: MonitoringM24EmessiReducer,
        valutazioniMonitoring: MonitoringValutazioniReducer,
        PersonaleContabile: PersonaleContabileReducer,
        notifiche2023: MonitoringNotifiche2023Reducer,
        ReportProvvedimenti: ReportProvvedimentiReducer

    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;

